<div id="hotelbooking" class="registration container" >
  <form #hotelbookingForm="ngForm" [ngClass]="{'form-complete': hotelbookingForm.valid}" name="hotelbookingForm"
    (ngSubmit)="forward(hotelbookingForm)" novalidate autocomplete="off" appScrollToInvalid
    [ngClass]="{'form-complete': isFormCompleted}">
    <h1>{{ 'copy.label.HOTEL.heading' | copy | async }}</h1>
    <!-- <mtc-alert></mtc-alert> -->

    <section class="card" *ngIf="attendee.PAXTypeNo === 4">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.government' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <mat-radio-group [(ngModel)]="accepRom.Value" name="acceptRoom" #acceptRoom="ngModel" required
          (ngModelChange)="changeAcceptRoom()">
          <mat-radio-button value="Yes" [checked]="acceptRoom.value === 'Yes'">Yes</mat-radio-button>
          <mat-radio-button value="No" [checked]="acceptRoom.value === 'No'">No</mat-radio-button>
          <div class="w-100">
            <mat-error><app-validation [object]="acceptRoom" isRequired=true></app-validation></mat-error>
          </div>
        </mat-radio-group>
      </article>
    </section>

    <section class="card"
      *ngIf="attendee.PAXTypeNo !== 4 ||  (attendee.PAXTypeNo === 4 && accepRom.Value !== undefined )">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.label' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <mat-radio-group [(ngModel)]="enrollment.HotelNeeded" name="hotelNeeded" #hotelNeeded="ngModel" required
          (ngModelChange)="clearRequests()">
          <mat-radio-button [value]="true" [checked]="enrollment.HotelNeeded === true">Yes</mat-radio-button>
          <mat-radio-button [value]="false" [checked]="enrollment.HotelNeeded === false">No</mat-radio-button>
          <div class="w-100">
            <mat-error><app-validation [object]="hotelNeeded" isRequired=true></app-validation></mat-error>
          </div>
        </mat-radio-group>
      </article>
    </section>


    <section class="card"
      *ngIf="attendee.PAXTypeNo === 4 && accepRom.Value === 'No' && enrollment.HotelNeeded === true ">
      <article class="w-100">
        <div class="agreeCheckbox">
          <div class="checkboxFlexContainer">
            <mat-checkbox name="hotelResp" [(ngModel)]="enrollment.$mtcRespHotel" #hotelResp="ngModel" required></mat-checkbox>
            <label class="required p-0 font-weight-bold">
               {{ 'copy.label.HOTEL.responsible' | copy | async }}
             </label>
          </div>
          <div class="w-100">
            <small class="text-danger"><app-validation class="w-100" [object]="hotelResp"
                isRequired=true></app-validation></small>
          </div>
        </div>
      </article>
    </section>




    <section class="card" *ngIf="enrollment.HotelNeeded === true">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.roominfo' | copy | async }}
        </div>
      </div>
      <article>

        <div>
            <span class="mt-3" [innerHTML]='getTextToShow()| async'></span>
        </div>

        <!--div *ngIf="attendee.PAXTypeNo !== 4 "> {{getTextToShow()| async }}
            <span class="mt-3" [innerHTML]='"copy.html.hotelCustomText"|copy|async'></span>
        </div>
        <div *ngIf="attendee.PAXTypeNo === 4 && accepRom.Value !== undefined && accepRom.Value !=='No'">
            <span class="mt-3" [innerHTML]='"copy.html.hotelCustomText_short"|copy|async'></span>
        </div>
        <div>
            <span class="mt-3" *ngIf="attendee.PAXTypeNo === 4 && accepRom.Value === 'No' && enrollment.HotelNeeded === true "
                   [innerHTML]='"copy.html.hotelCustomText"|copy|async'>
            </span>
        </div-->
        
        

      </article>
      <article>
        <app-hotel-pref class="w-100 mt-3"></app-hotel-pref>

        <div class="d-flex justify-content-center w-100">
          <mat-form-field class="w-100">
            <mat-label class="w-100" for="DietaryNeedOther" aria-labelledby="DietaryNeedOther">{{
              'copy.label.HOTEL.special' |copy |async}}</mat-label>
            <textarea matInput class="w-100" name="hotelSpecialRequests" #special="ngModel"
              [(ngModel)]="enrollment.HotelSpecialRequests" maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*"></textarea>
            <mat-error><app-validation [object]="special" isRequired=true
                pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>
        </div>
      </article>
    </section>

    <section class="card" *ngIf="enrollment.HotelNeeded === false">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.nohotellabel' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <mat-radio-group [(ngModel)]="enrollment.HotelSpecialRequests" name="noHotelReason" #noHotelReason="ngModel"
          required>
          <mat-radio-button *ngFor="let op of noHotelRadios" [value]="op.value">{{op.display}}</mat-radio-button>
          <div class="w-100">
            <mat-error><app-validation [object]="noHotelReason" isRequired=true></app-validation></mat-error>
          </div>
        </mat-radio-group>

      </article>
    </section>
    <div class="button_group d-flex">
      <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()"
        *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.goback' | copy | async }}
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.continue' | copy | async }}
      </button>
      <button class="inputSubmit btn btn-primary ms-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
</div>